import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./umzug.css";
import HeroSection from "../heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";
import NavbarMenu from "../heroSection/NavbarMenu";
import { AiFillTag, AiOutlineLike, AiOutlineSafety } from "react-icons/ai";
import { FaCalculator, FaEuroSign, FaHeadphones, FaTasks, FaTruckMoving, FaUsers } from "react-icons/fa";
import { SlEarphones } from "react-icons/sl";
import { MdMoneyOff, MdOutlineAttachMoney } from "react-icons/md";
import { RiLock2Fill } from "react-icons/ri";
import { IoTimeOutline } from "react-icons/io5";
import { CgCircleci } from "react-icons/cg";
import { LuNotebookPen, LuNotepadText } from "react-icons/lu";
import { BiSolidLike } from "react-icons/bi";
import IMG_HERO_BG from "../../assets/images/umzug-bg.jpg";
import { useNavigate } from "react-router-dom";
import UmzugNavbarMenu from "../heroSection/UmzugNavbarMenu";
import { TbCurrencyEuroOff } from "react-icons/tb";

/* ── Unsplash image URLs – replace with local assets if preferred ── */
// const IMG_HERO_BG =
//   "https://tuggerahremovals.com.au/wp-content/uploads/Tuggerah-Removals-and-storage-carton-loading-truck.webp";
const IMG_MOVER_MAIN =
  "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=600&q=80";
const IMG_SOFA =
  "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&q=80";
const IMG_BOXES =
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&q=80";

export default function Umzug({
  showNavbar = true,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();


  const trustBadges = [
    { 
      icon: <FaEuroSign />, 
      label1: t("umzug.trust.free.label1", "Kostenlos &"), 
      label2: t("umzug.trust.free.label2", "unverbindlich") 
    },
    { 
      icon: <AiOutlineSafety />, 
      label1: t("umzug.trust.secure.label1", "Geprüfte &"), 
      label2: t("umzug.trust.secure.label2", "zuverlässige Partner") 
    },
    { 
      icon: <IoTimeOutline />, 
      label1: t("umzug.trust.fast.label1", "Schnelle"), 
      label2: t("umzug.trust.fast.label2", "Angebote") 
    },
  ]

  const whyCards = [
    {
      icon: <FaUsers />,
      title: t("umzug.why.card1.title", "Viele Angebote vergleichen"),
      text: t(
        "umzug.why.card1.text",
        "Erhalten Sie mehrere Angebote und wählen Sie das beste für Ihren Umzug."
      ),
    },
    {
      icon: <AiFillTag />,
      title: t("umzug.why.card2.title", "Bis zu 30% sparen"),
      text: t(
        "umzug.why.card2.text",
        "Durch den Vergleich sparen Sie Zeit und Geld bei Ihrem Umzug."
      ),
    },
    {
      icon: <BiSolidLike />,
      title: t("umzug.why.card3.title", "Geprüfte Umzugsfirmen"),
      text: t(
        "umzug.why.card3.text",
        "Alle Partner werden von uns geprüft und laufend bewertet."
      ),
    },
    {
      icon: <FaHeadphones />,
      title: t("umzug.why.card4.title", "Persönlicher Support"),
      text: t(
        "umzug.why.card4.text",
        "Unser Team hilft Ihnen bei Fragen rund um Ihren Umzug weiter."
      ),
    },
  ];

  const howSteps = [
    {
      num: "1",
      icon: <LuNotebookPen />,
      title: t("umzug.how.step1.title", "Umzugsdetails eingeben"),
      text: t(
        "umzug.how.step1.text",
        "Geben Sie Abhol- und Zieladresse, Umzugsdatum und Details an."
      ),
    },
    {
      num: "2",
      icon: <LuNotepadText />,
      title: t("umzug.how.step2.title", "Angebote erhalten"),
      text: t(
        "umzug.how.step2.text",
        "Erhalten Sie kostenlos mehrere Angebote von Umzugsfirmen in Ihrer Nähe."
      ),
    },
    {
      num: "3",
      icon: <FaTasks />,
      title: t("umzug.how.step3.title", "Angebote vergleichen"),
      text: t(
        "umzug.how.step3.text",
        "Vergleichen Sie Preise, Leistungen und Bewertungen der Anbieter."
      ),
    },
    {
      num: "4",
      icon: <FaTruckMoving />,
      title: t("umzug.how.step4.title", "Umzug beauftragen"),
      text: t(
        "umzug.how.step4.text",
        "Wählen Sie das passende Angebot und beauftragen Sie Ihren Umzug."
      ),
    },
  ];

  const trustCards = [
    {
      icon: <TbCurrencyEuroOff />,
      title: t("umzug.trustBar.free.title", "100% kostenlos"),
      text: t("umzug.trustBar.free.text", "Keine versteckten Kosten"),
    },
    {
      icon: <RiLock2Fill />,
      title: t("umzug.trustBar.secure.title", "Sicher & vertraulich"),
      text: t("umzug.trustBar.secure.text", "Ihre Daten sind geschützt"),
    },
    {
      icon: <IoTimeOutline />,
      title: t("umzug.trustBar.fast.title", "Schnell & unkompliziert"),
      text: t("umzug.trustBar.fast.text", "In nur wenigen Minuten"),
    },
    {
      icon: <CgCircleci />,
      title: t("umzug.trustBar.nationwide.title", "Deutschlandweit"),
      text: t("umzug.trustBar.nationwide.text", "Umzüge in ganz Deutschland"),
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const handleSelect = () => {
    setTimeout(() => {
      navigate(`/transport?type=moving`);
    }, 150);
  };

  /* ─────────────────────────── render ─────────────────────────── */
  return (
    <>
      <SEO
        title={t("umzug.seo.title", "TransCirox – Umzug leicht gemacht")}
        description={t(
          "umzug.seo.description",
          "Erhalten Sie kostenlos mehrere Umzugsangebote von geprüften Umzugsunternehmen in Ihrer Nähe."
        )}
      />

      {/* ── Original HeroSection (Navbar etc.) ── */}
      {showNavbar && <UmzugNavbarMenu />}

      {/* ════════════════════════════════════════
          HERO – "Umzug leicht gemacht"
      ════════════════════════════════════════ */}
      <section
        className="umzug-hero"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(27 27 27 / 97%) 45%, rgb(51 51 51 / 55%) 70%, transparent 100%), url(${IMG_HERO_BG})`,
        }}
        aria-label="Hero"
      >
        <Container>
          <div className="hero-content" data-aos="fade-right">
            <h1>
              {t("umzug.hero.title", "Umzug leicht gemacht")}
              <span>{t("umzug.hero.tagline", "Vergleichen. Sparen. Umziehen.")}</span>
            </h1>

            <p className="hero-subtitle">
              {t(
                "umzug.hero.subtitle",
                "Erhalten Sie kostenlos mehrere Umzugsangebote von geprüften Umzugsunternehmen in Ihrer Nähe. Schnell, einfach und unverbindlich."
              )}
            </p>

            {/* ── Trust badges ── */}
            <div className="trust-badges">
              {trustBadges.map(({ icon, label1, label2 }, i) => (
                <div className="trust-badge" key={i}>
                  <div className="badge-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: label1 }} />
                    <div>{label2}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* ── CTA button ── */}
            <a className="btn-orange" onClick={() => handleSelect()}>
              {t("umzug.hero.cta", "Jetzt Umzugsangebot erhalten")} →
            </a>

            <p className="hero-data-note">
              <AiOutlineSafety /> {" "}
              {t(
                "umzug.hero.dataNote",
                "Ihre Daten sind bei uns sicher und werden nicht weitergegeben."
              )}
            </p>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          WHY TRANSCIROX
      ════════════════════════════════════════ */}
      <section className="why-section">
        <Container>
          <h2 className="section-title" data-aos="fade-up">
            {t("umzug.why.title", "Warum TransCirox?")}
          </h2>
          <p className="section-subtitle" data-aos="fade-up" data-aos-delay="50">
            {t("umzug.why.subtitle", "Ihre Vorteile auf einen Blick")}
          </p>

          <Row className="g-4 justify-content-center">
            {whyCards.map(({ icon, title, text }, i) => (
              <Col xs={12} sm={6} lg={3} key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="why-card">
                  <div className="icon-wrap" aria-hidden="true">
                    {icon}
                  </div>
                  <h5>{title}</h5>
                  <p>{text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          HOW IT WORKS
      ════════════════════════════════════════ */}
      <section className="how-section">
        <Container>
          <h2 className="section-title" data-aos="fade-up">
            {t("umzug.how.title", "So einfach funktioniert's")}
          </h2>

          <div className="steps-container" data-aos="fade-up" data-aos-delay="100">
            <div className="steps-row">
              {howSteps.map(({ num, icon, title, text }, i, arr) => (
                <div className="step-item" key={i}>
                  <div className="step-circle">
                    <span className="step-number">{num}</span>
                    <div className="step-icon">{icon}</div>
                  </div>
                  {i < arr.length - 1 && (
                    <div className="step-connector" aria-hidden="true">
                      <div className="connector-line"></div>
                      {/* <div className="connector-arrow">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path
                            d="M6 0L6 9"
                            stroke="#ff6b00"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            d="M3 6L6 9L9 6"
                            stroke="#ff6b00"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div> */}
                    </div>
                  )}
                  <h6 className="step-title">{title}</h6>
                  <p className="step-text">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          SOLUTIONS – "Für jeden Umzug"
      ════════════════════════════════════════ */}
      <section className="solutions-section">
        <Container>
          <Row className="align-items-center g-5">
            {/* Text col */}
            <Col md={5} data-aos="fade-right">
              <div className="solutions-content">
                <h2>
                  {t("umzug.solutions.title1", "Für jeden Umzug")}
                  <br />
                  {t("umzug.solutions.title2", "die passende Lösung")}
                </h2>
                <p className="text-muted">
                  {t(
                    "umzug.solutions.text",
                    "Egal ob Privatumzug, Firmenumzug oder Seniorenumzug – wir bringen Sie ans Ziel."
                  )}
                </p>
                <ul className="solutions-list">
                  {[
                    t("umzug.solutions.list.1", "Privatumzug"),
                    t("umzug.solutions.list.2", "Firmenumzug"),
                    t("umzug.solutions.list.3", "Nah- und Fernumzug"),
                    t("umzug.solutions.list.4", "Seniorenumzug"),
                    t("umzug.solutions.list.5", "Ein- und Auspackservice"),
                    t("umzug.solutions.list.6", "Möbelmontage"),
                  ].map((item, i) => (
                    <li key={i}>
                      <span className="check">✓</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Images col */}
            <Col md={7} data-aos="fade-left">
              <div className="solutions-images">
                <img
                  src={IMG_MOVER_MAIN}
                  alt="Umzugshelfer mit Karton"
                  className="img-main"
                />
                <img src={IMG_SOFA} alt="Möbeltransport" />
                <img src={IMG_BOXES} alt="Umzugskartons" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          BOTTOM TRUST BAR
      ════════════════════════════════════════ */}
      <section className="trust-bar">
        <Container>

          {/* ════════════════════════════════════════
               CTA DARK SECTION
           ════════════════════════════════════════ */}
          <section className="cta-section" id="angebot" data-aos="fade-up">
            <Container>
              <Row className="align-items-center gy-4">
                <Col xs="auto">
                  <div className="cta-icon-wrap" aria-hidden="true">
                    <FaCalculator />
                  </div>
                </Col>

                <Col className="cta-text">
                  <h3>
                    {t("umzug.cta.title", "Bereit für Ihren Umzug?")}
                  </h3>
                  <p>
                    {t(
                      "umzug.cta.text",
                      "Starten Sie jetzt Ihre Anfrage und erhalten Sie kostenlos mehrere Umzugsangebote."
                    )}
                  </p>
                </Col>

                <Col xs={12} sm="auto" className="cta-action text-center">
                  <a onClick={() => handleSelect()} className="btn-orange">
                    {t("umzug.cta.btn", "Jetzt Angebot erhalten")} →
                  </a>
                  <p className="time-note">
                    {t("umzug.cta.timeNote", "Dauert nur 2 Minuten")}
                  </p>
                </Col>
              </Row>
            </Container>
          </section>

          <Row className="g-4 justify-content-center">
            {trustCards.map(({ icon, title, text }, i) => (
              <Col xs={6} md={3} key={i}>
                <div className="trust-bar-item">
                  <div className="tb-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <h6>{title}</h6>
                    <p>{text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      {/* ════════════════════════════════════════
          FAQ
      ════════════════════════════════════════ */}
      <div className="faq-umzug">
        <p className="fw-bold text-center">{t("umzug.FaqUmzug.hero_description")}</p>

        <Row>
          <Col className="d-flex justify-content-center p-3">
            <Button
             onClick={() => navigate("/faq-umzug")}
              className="btn btn-orange p-3"
            >
              {t("umzug.FaqUmzug.hero_title")}
            </Button>
          </Col>
        </Row>
      </div>

      <Footer />
    </>
  );
}